'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { Splide, SplideSlide, Options } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import showRowSplideStyles from './ShowRowSplide.module.scss';
import styles from './ShowRow.module.scss';

import { SHOW_ROW_SPLIDE_OPTIONS } from '@/lib/constants';
import ContentRowTitleDescription from '@/components/ContentRowTitleDescription/ContentRowTitleDescription';

import { ShowRowContent } from '@/lib/types/api/show-data';
import { Franchise } from '@/lib/types/api/franchise-data';

import ShowPoster from '@/components/ShowPoster/ShowPoster';

export interface ShowRowProps {
  className?: string;
  description?: string | null;
  hideShowBadges?: boolean;
  logo?: string;
  logo_alt?: string;
  overRideOptions?: Options;
  onShowPosterClick?: (show: ShowRowContent, index?: number, linkHref?: string) => void;
  shows: Array<ShowRowContent | Franchise>;
  title?: string;
}

export default function ShowRow(props: ShowRowProps) {
  const {
    className,
    description,
    hideShowBadges,
    logo_alt,
    logo,
    onShowPosterClick,
    overRideOptions,
    shows,
    title,
  } = props;

  let options: Options = {
    ...SHOW_ROW_SPLIDE_OPTIONS,
    classes: {
      list: `splide__list ${showRowSplideStyles.splide__list}`,
      arrow: `splide__arrow ${showRowSplideStyles.splide__arrow}`
    }
  }

  if (overRideOptions) {
    options = {
      ...options,
      ...overRideOptions
    }
  }

  let classNames = styles.show_row;

  if (className) {
    classNames += ` ${className}`;
  }

  return (
    <div className={classNames}>
      { title && (
        <ContentRowTitleDescription
          title={title}
          description={description}
          logo={logo}
          logo_alt={logo_alt}
        />
      )}

      <Splide options={options}>
        {shows.map((show, index) => (
          <SplideSlide key={`${index}${show.slug}`} className={styles.splide__slide}>
            <ShowPoster
              index={index}
              onClick={onShowPosterClick}
              show={show}
              hideShowBadges={hideShowBadges}
              className={styles.show_row__show_poster}
            />
          </SplideSlide>
        ))}
      </Splide>
    </div>
  )
}
